import { ReturnsFlagKey } from "@redotech/feature-flags-keys-returns/keys";
import { memo, useContext, useMemo } from "react";
import { SettingsContext } from "../contexts/settings";
import { buildPortalCustomizationCss } from "./build-portal-customization-css";
import { CustomizationContext } from "./customization-context";

export const PortalCustomizationStyleTag = memo(
  function PortalCustomizationStyleTag() {
    const { customization } = useContext(CustomizationContext);
    const settings = useContext(SettingsContext);
    const modalless =
      !!settings?.featureFlags?.[ReturnsFlagKey.ENABLE_MODALLESS_PORTAL];
    const css = useMemo(
      () =>
        customization
          ? buildPortalCustomizationCss(customization, {
              customFontFamilies: settings?.brandKit?.customFontFamilies,
              modalless,
            })
          : "",
      [customization, settings?.brandKit?.customFontFamilies, modalless],
    );
    if (!css) {
      return null;
    }
    return <style>{css}</style>;
  },
);
